import { render } from "./AppSubmenu.vue?vue&type=template&id=9985083c&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import "./AppSubmenu.vue?vue&type=style&index=0&id=9985083c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9985083c"]])

export default __exports__